export  const debounce = (fn, delay = 500) => {
    let timer = null
    return function () {
      let _this = this
      let _arguments = arguments
      clearTimeout(timer)
      timer = setTimeout(function () {
        console.log('执行器触发')
        fn.apply(_this, _arguments)
      }, delay)
    }
  }



// WEBPACK FOOTER //
// ./src/utils/debounce.js